import { STORE_SERVICES } from '../../../../../views/phone-answering/constants';

export default {
  title: 'Services',
  options: {
    [STORE_SERVICES.CATERING]: 'Catering',
    [STORE_SERVICES.TERRACE]: 'Terrace available',
    [STORE_SERVICES.DINE_IN]: 'Dine in',
    [STORE_SERVICES.ONLINE_ORDERING]: 'Online ordering via FoodAmigos',
    [STORE_SERVICES.RESERVATION]: 'Reservations via FoodAmigos',
    [STORE_SERVICES.INTERNAL_RESERVATION]: 'Reservations in restaurant',
  },
  labels: {
    reservation_total_seats: 'Reservation total seats',
    catering_min_people: 'Catering min people',
  },
};
